'use strict';

var __makeTemplateObject =
  (void 0 && (void 0).__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', {
        value: raw,
      });
    } else {
      cooked.raw = raw;
    }

    return cooked;
  };

var __createBinding =
  (void 0 && (void 0).__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
          enumerable: true,
          get: function get() {
            return m[k];
          },
        });
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });

var __setModuleDefault =
  (void 0 && (void 0).__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', {
          enumerable: true,
          value: v,
        });
      }
    : function (o, v) {
        o['default'] = v;
      });

var __importStar =
  (void 0 && (void 0).__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod) {
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
      }

    __setModuleDefault(result, mod);

    return result;
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.StyledTypography = void 0;

var styled_components_1 = __importStar(require('styled-components'));

var themeFonts_1 = require('../../constants/themeFonts');

var components_1 = require('../../constants/components');

var spacingGenerators_1 = require('../../utils/spacingGenerators');

var generateStaticFont = function generateStaticFont(_a) {
  var isStatic = _a.isStatic,
    variant = _a.variant;

  if (!isStatic) {
    return styled_components_1.css(
      templateObject_1 ||
        (templateObject_1 = __makeTemplateObject(['\n      ', ';\n    '], ['\n      ', ';\n    '])),
      themeFonts_1.themeAdaptiveFonts[components_1.BREAKPOINTS.mobile_small][variant]
    );
  }

  return styled_components_1.css(
    templateObject_2 ||
      (templateObject_2 = __makeTemplateObject(['\n    ', ';\n  '], ['\n    ', ';\n  '])),
    themeFonts_1.themeAdaptiveFonts[components_1.BREAKPOINTS.desktop_small][variant]
  );
};

var generateAdaptiveFont = function generateAdaptiveFont(_a) {
  var isStatic = _a.isStatic,
    variant = _a.variant;

  if (!isStatic) {
    return styled_components_1.css(
      templateObject_3 ||
        (templateObject_3 = __makeTemplateObject(
          [
            '\n      @media screen and (min-width: ',
            'px) {\n        ',
            ';\n      }\n\n      @media screen and (min-width: ',
            'px) {\n        ',
            ';\n      }\n    ',
          ],
          [
            '\n      @media screen and (min-width: ',
            'px) {\n        ',
            ';\n      }\n\n      @media screen and (min-width: ',
            'px) {\n        ',
            ';\n      }\n    ',
          ]
        )),
      components_1.BREAKPOINTS.mobile_large,
      themeFonts_1.themeAdaptiveFonts[components_1.BREAKPOINTS.mobile_large][variant],
      components_1.BREAKPOINTS.desktop_small,
      themeFonts_1.themeAdaptiveFonts[components_1.BREAKPOINTS.desktop_small][variant]
    );
  }

  return '';
};

exports.StyledTypography = styled_components_1.default.p(
  templateObject_4 ||
    (templateObject_4 = __makeTemplateObject(
      ['\n  color: ', ';\n  margin: 0;\n\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n'],
      ['\n  color: ', ';\n  margin: 0;\n\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n']
    )),
  function (_a) {
    var color = _a.color;
    return color;
  },
  generateStaticFont,
  generateAdaptiveFont,
  spacingGenerators_1.generateSpacing,
  spacingGenerators_1.generateTopSpacing,
  spacingGenerators_1.generateBottomSpacing
);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
